(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mxy-bundle-carousel"] && !Shopify.designMode) return;
  try {
    (() => {
    const listSelector = '[class*="horizontalBundleItems_container_"], [class*="verticalBundleItems_container_"]';
    const cardSelector = '[class*="BundleItems_item_wrapper_"]';
    const productCache = new Map();

    if (!customElements.get('mxy-bundle-carousel')) {
      customElements.define('mxy-bundle-carousel', class extends HTMLElement {
        connectedCallback() {
          this.controller = new AbortController();
          const options = { signal: this.controller.signal };
          this.previous = this.querySelector('.mxy-bundles__arrow--previous');
          this.next = this.querySelector('.mxy-bundles__arrow--next');
          this.previous.addEventListener('click', () => this.advance(-1), options);
          this.next.addEventListener('click', () => this.advance(1), options);
          this.addEventListener('change', () => this.schedule(), options);
          this.observer = new MutationObserver(() => this.schedule());
          this.observer.observe(this, { childList: true, subtree: true });
          this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
          this.resizeObserver.observe(this);
          this.schedule();
        }

        disconnectedCallback() {
          this.controller?.abort();
          this.observer?.disconnect();
          this.resizeObserver?.disconnect();
          cancelAnimationFrame(this.frame);
        }

        schedule() {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.refresh());
        }

        refresh() {
          const list = this.querySelector(listSelector);
          if (!list) return;
          if (list !== this.list) {
            this.list = list;
            list.addEventListener('scroll', () => this.updateNavigation(), { passive: true, signal: this.controller.signal });
          }
          this.querySelectorAll(cardSelector).forEach(card => {
            const title = card.querySelector('[class*="BundleItems_title_"]');
            const name = title?.textContent.replace(/^Este art[ií]culo:\s*/, '').trim() || '';
            const checkbox = card.querySelector('input[type="checkbox"]');
            if (checkbox && !checkbox.hasAttribute('aria-label')) checkbox.setAttribute('aria-label', `${this.dataset.selectLabel} ${name}`);
            const select = card.querySelector('select');
            if (select && !select.hasAttribute('aria-label')) select.setAttribute('aria-label', `${this.dataset.variantLabel} ${name}`);
            this.updateComparePrice(card);
          });
          this.updateNavigation();
        }

        advance(direction) {
          if (!this.list) return;
          const card = this.list.querySelector(cardSelector);
          this.list.scrollBy({ left: direction * ((card?.getBoundingClientRect().width || 170) + 10), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }

        updateNavigation() {
          if (!this.list) return;
          const max = this.list.scrollWidth - this.list.clientWidth;
          this.previous.disabled = this.list.scrollLeft < 2;
          this.next.disabled = max < 2 || this.list.scrollLeft >= max - 2;
          const thumbnail = this.list.querySelector('[class*="BundleItems_thumbnail_wrapper_"]');
          if (thumbnail) {
            const photo = thumbnail.getBoundingClientRect();
            const host = this.getBoundingClientRect();
            this.style.setProperty('--mxy-arrow-top', `${photo.top - host.top + photo.height / 2 - 18}px`);
          }
        }

        async updateComparePrice(card) {
          const link = card.querySelector('a[href*="/products/"]');
          if (!link) return;
          const url = new URL(link.href, location.origin);
          if (url.origin !== location.origin) return;
          const key = url.pathname;
          if (!productCache.has(key)) {
            productCache.set(key, fetch(`${key}.js`, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(response => response.ok ? response.json() : null).catch(() => null));
          }
          const product = await productCache.get(key);
          if (!product || !card.isConnected) return;
          const selected = card.querySelector('select')?.value;
          const variant = product.variants.find(item => String(item.id) === selected) || product.variants.find(item => item.available) || product.variants[0];
          const price = card.querySelector('[class*="BundleItems_priceTagWrapper_"]');
          if (!price || !variant) return;
          let compare = price.querySelector('.mxy-bundles__compare');
          if (variant.compare_at_price > variant.price) {
            if (!compare) {
              compare = document.createElement('s');
              compare.className = 'mxy-bundles__compare';
              price.appendChild(compare);
            }
            const formatted = '$' + new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(variant.compare_at_price / 100);
            if (compare.textContent !== formatted) compare.textContent = formatted;
          } else if (compare) compare.remove();
        }
      });
    }

    let scheduled = false;
    function mount() {
      scheduled = false;
      const template = document.getElementById('mxy-bundle-carousel-template');
      const form = document.querySelector('.product__info-container product-form');
      if (!template || !form) return;
      let carousel = form.parentElement.querySelector(':scope > mxy-bundle-carousel');
      let offer = form.parentElement.querySelector(':scope > .mxy-3x2');
      if (!carousel) {
        form.after(template.content.cloneNode(true));
        carousel = form.parentElement.querySelector(':scope > mxy-bundle-carousel');
        offer = form.parentElement.querySelector(':scope > .mxy-3x2');
      }
      if (form.nextElementSibling !== offer) form.after(offer);
      if (offer.nextElementSibling !== carousel) offer.after(carousel);
      const widget = document.getElementById('rbr-container-element-fbt');
      if (widget && widget.parentElement !== carousel) carousel.querySelector('.rbrFBTPosition').after(widget);
    }

    function start() {
      const main = document.getElementById('MainContent');
      if (!main) return;
      mount();
      new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(mount);
      }).observe(main, { childList: true, subtree: true });
      document.addEventListener('shopify:section:load', mount);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
